/* eslint-disable import/no-anonymous-default-export */
import { toast } from "react-toastify";

export default {
  serverError: (error) => {
    toast.error(error ?? "Error from the server. Please try again later!");
  },
};
